import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { LessorType } from "@shared/enums/lessorType";
import { LessorDataDto } from "@shared/models/policy-details";
import { DividerModule } from "primeng/divider";

@Component({
  selector: "app-lessor-informations-mrh",
  standalone: true,
  imports: [CommonModule, TranslateModule, DividerModule],
  templateUrl: "./lessor-informations-mrh.component.html",
  styleUrl: "./lessor-informations-mrh.component.scss",
})
export class LessorInformationsMrhComponent {
  @Input() lessor!: LessorDataDto;
  @Input() lessorDateSentTerminationLetter!: string;

  lessorType = LessorType;
}
